import { serviceColumns } from '@Constants/TableColumns';
import { FrameEditService } from '@Modules/Stammdaten';
import {
    Grid,
    GridColumn,
    GridColumns,
    LinkedField,
    NumberInput,
    Select,
    TextInput,
    isLinked,
    useAutoConfirmed,
    useGuiBinder,
    useLinkedField,
    useLinkProperty,
    useProp,
    type ISubFrameBodyProps,
    DateInput,
} from '@synqo/frontend-component-library';
import { EnumUnit, shortUnitOptions, type ApiPriceListPosition, type ApiService } from '@Model';

export function FramePriceListPosition(props: ISubFrameBodyProps<ApiPriceListPosition>) {
    const pos: ApiPriceListPosition = props.data;
    const baseApiObjectPath = `${props.apiResourcePath}/${props.data.id}`;

    const binder = useGuiBinder<ApiPriceListPosition>(props);

    const linkService = useLinkedField<ApiPriceListPosition, ApiService>(
        baseApiObjectPath,
        'service',
        FrameEditService,
        true,
        props.requestUpdateState,
    );

    const serviceField = useLinkProperty(binder, linkService.linkApi);
    const unitField = useAutoConfirmed<ApiPriceListPosition, EnumUnit>(binder, 'unit');
    const pricePerUnitField = useProp<ApiPriceListPosition, number>(binder, 'price_per_unit');
    const validFromField = useProp(binder, 'valid_from');
    const validUntilField = useProp(binder, 'valid_until');
    const remarksField = useProp(binder, 'remarks');

    return (
        <div className={'w-full'}>
            <Grid columns={8}>
                <GridColumns spans={[3, 1, 4]}>
                    <LinkedField<ApiService>
                        {...serviceField}
                        {...linkService.events}
                        columns={serviceColumns}
                        label="Leistung"
                    />
                    <Select<EnumUnit> items={shortUnitOptions} {...unitField} label={'Einheit'} locked />
                    <NumberInput
                        {...pricePerUnitField}
                        decimals={pos.decimal_places_price}
                        label="Einzelpreis"
                        locked={!isLinked(pos.service)}
                    />
                </GridColumns>
                <GridColumns spans={[4, 4]}>
                    <DateInput type="day" {...validFromField} label="Gültig ab" required />
                    <DateInput type="day" {...validUntilField} label="Gültig bis" />
                </GridColumns>
                <GridColumn span={8}>
                    <TextInput {...remarksField} label="Bemerkung" />
                </GridColumn>
            </Grid>
        </div>
    );
}
